import React from 'react';
import { Section } from '../ui/Section';
import { XCircle } from 'lucide-react';
export function Pain() {
  return <Section background="off-white" data-id="element-173">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-stone-900" data-id="element-174">
        Si esto te pasa, no estás sola.
      </h2>

      <div className="space-y-6" data-id="element-175">
        {['Te prometiste que "esta semana sí"… y el martes ya estás improvisando.', 'Te cansaste de recetas perfectas que no se adaptan a tu casa, tu bolsillo, ni tu energía.', 'Sentís que pensar la comida te ocupa la cabeza todo el día.', 'Tenés miedo de equivocarte y después pagarlo con culpa.'].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-stone-100" data-id="element-176">
            <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-177" />
            <p className="text-lg text-stone-700 font-medium" data-id="element-178">{item}</p>
          </div>)}
      </div>

      <div className="mt-12 text-center" data-id="element-179">
        <p className="text-2xl font-bold text-stone-900" data-id="element-180">
          No es falta de ganas.{' '}
          <span className="text-emerald-700 underline decoration-4 decoration-emerald-200 underline-offset-4" data-id="element-181">
            Es falta de sistema.
          </span>
        </p>
      </div>
    </Section>;
}